import { render, staticRenderFns } from "./TabelaBrasindice.vue?vue&type=template&id=8fa49fa2&"
import script from "./TabelaBrasindice.vue?vue&type=script&lang=js&"
export * from "./TabelaBrasindice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports